import { render } from "./LivingBuildings.vue?vue&type=template&id=365b782d"
import script from "./LivingBuildings.vue?vue&type=script&lang=js"
export * from "./LivingBuildings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__